export default __webpack_public_path__ + "static/media/gold_reveal.086b0df4.mp3";